//frontend/src/components/InfoManage/InfoManage.js

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, Routes, Route } from "react-router-dom";

import { FaPlusCircle, FaListUl, FaKey, FaUserShield } from "react-icons/fa";

import AddPopForm from "./AddPopForm";
import EditPopForm from "./EditPopForm";
import PopList from "./PopList";
import Credentials from "./Credentials";
import VisitorInfo from "./VisitorInfo";

import "./InfoManage.css";

const InfoManage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selected, setSelected] = useState(null);

  const menuItems = [
    {
      key: "add_pop",
      label: t("add_pop"),
      icon: <FaPlusCircle />,
      path: "/info-manage/add-pop",
      color: "add",
    },
    {
      key: "pop_list",
      label: t("view_pop_list"),
      icon: <FaListUl />,
      path: "/info-manage/pop-list",
      color: "list",
    },
    {
      key: "credentials",
      label: t("credentials"),
      icon: <FaKey />,
      path: "/info-manage/credentials",
      color: "cred",
    },
    {
      key: "visitor_info",
      label: t("visitor_info"),
      icon: <FaUserShield />,
      path: "/info-manage/visitor-info",
      color: "visitor",
    },
  ];

  const handleClick = (item) => {
    setSelected(item.key);
    navigate(item.path);
  };

  const activeRoute = menuItems.find((m) => m.key === selected);

  return (
    <div className="info-manage-container">
      <h2 className="form-title">{t("info_manage")}</h2>

      {/* GRID MENU */}
      <div className="info-grid">
        {menuItems.map((item) => (
          <div
            key={item.key}
            className={`info-card ${item.color} ${
              selected === item.key ? "active" : ""
            }`}
            onClick={() => handleClick(item)}
          >
            <div className="info-icon">{item.icon}</div>
            <div className="info-label">{item.label}</div>
          </div>
        ))}
      </div>

      {/* ROUTES OUTPUT */}
      <div className="info-output">
        <Routes>
          <Route path="add-pop" element={<AddPopForm />} />
          <Route path="edit-pop/:id" element={<EditPopForm />} />
          <Route path="pop-list" element={<PopList />} />
          <Route path="credentials" element={<Credentials />} />
          <Route path="visitor-info" element={<VisitorInfo />} />
        </Routes>
      </div>
    </div>
  );
};

export default InfoManage;
